import React, { Component, useState, useEffect } from "react";
import "./VideosRowItem.css";
import "./VideoPlayerItem.css";
import { IoArrowBack, IoArrowRedoOutline } from "react-icons/io5";
import {
  IoMdHeartEmpty,
  IoMdHeart,
  IoIosCheckmarkCircle,
} from "react-icons/io";
import Wallet from "./Wallet";
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";
import axios from "axios";
import Web3 from "web3";
import { useNavigate } from "react-router-dom";

function VideosRowItem(props) {
  const navigate = useNavigate();
  const [copyMessage, setCopyMessage] = useState("");
  const [isCopied, setIsCopied] = useState(false);
  const [isHeartClicked, setIsHeartClicked] = useState(props.video.userVote);
  const [totalListenTime, setTotalListenTime] = useState(0);
  const [totalUpvotes, setTotalUpvotes] = useState(props.video.totalUpvotes);
  const [usdPrice, setUsdPrice] = useState(
    "Invalid coinbase exchange rate request"
  );
  const [isFinished, setIsFinished] = useState(false);
  const ethToWeiConversion = 1000000000000000000;

  useEffect(() => {
    setIsHeartClicked(props.video.userVote);
  }, [props.video.userVote]);

  useEffect(() => {
    setTotalUpvotes(props.video.totalUpvotes);
  }, [props.video.totalUpvotes]);

  useEffect(() => {
    const getUSDETH = async () => {
      let USDPriceETH = "Invalid coinbase exchange rate request";
      let data = await axios.get("https://api.coinbase.com/v2/exchange-rates", {
        params: { currency: "ETH" },
      });
      if (data != null) {
        USDPriceETH = data["data"]["data"]["rates"]["USD"];
      }
      return USDPriceETH;
    };
    getUSDETH().then((price) => setUsdPrice(price));
  }, []);

  function handleClickVideo() {
    loggingUtils.logEvent(
      props.address != null ? props.address : encryptUtils.getWalletUnconnectedUserId(),
      "videos_item",
      "videos_item_click_video",
      "info",
      "https://the402.xyz",
      {
        video: props.video,
      }
    );
    let route =
      "/media/" + props.video.authUUID + "?protocol=" + props.video.protocol;
    navigate(route);
  }

  function handleClickMarketplace() {
    loggingUtils.logEvent(
      props.address != null ? props.address : encryptUtils.getWalletUnconnectedUserId(),
      "videos_item",
      "videos_item_click_marketplace",
      "info",
      "https://the402.xyz",
      {
        video: props.video,
      }
    );
    let route =
      "/marketplace/" +
      props.video.authUUID +
      "?protocol=" +
      props.video.protocol;
    navigate(route);
  }

  function onClickShareLink(e) {
    e.stopPropagation();
    let shareLink =
      window.location.origin +
      "/media/" +
      props.video.authUUID +
      "?protocol=" +
      props.video.protocol;
    navigator.clipboard.writeText(shareLink);
    setIsCopied(true);
    setCopyMessage("Copied");
    loggingUtils.logEvent(
      props.address != null ? props.address : encryptUtils.getWalletUnconnectedUserId(),
      "videos",
      "videos_share_item",
      "info",
      "https://the402.xyz",
      {
        video: props.video,
      }
    );
    setTimeout(() => {
      setIsCopied(false);
      setCopyMessage("");
    }, 2000);
  }

  function onUserClickedConnectWallet(event) {
    loggingUtils.logEvent(
      encryptUtils.getWalletUnconnectedUserId(),
      "videos",
      event,
      "info",
      "https://the402.xyz",
      {
        video: props.video,
      }
    );
    let buttons = document.getElementsByTagName("button");
    for (let i = 0; i < buttons.length; i++) {
      let button = buttons[i];
      if (button.outerText === "Connect Wallet") {
        button.click();
      }
    }
  }

  async function onClickHeart() {
    if (props.address == null) {
      onUserClickedConnectWallet("videos_like_item_with_wallet_disconnected");
    } else {
      let uriSplit = props.video.uri.split("/");
      let tokenCID = uriSplit[uriSplit.length - 1];
      if (!isHeartClicked) {
        await encryptUtils.logUpvote(tokenCID, props.address);
        loggingUtils.logEvent(
          props.address != null ? props.address : encryptUtils.getWalletUnconnectedUserId(),
          "videos",
          "videos_like_item",
          "info",
          "https://the402.xyz",
          {
            video: props.video,
          }
        );
        setIsHeartClicked(true);
        setTotalUpvotes(totalUpvotes + 1);
      } else {
        await encryptUtils.logRemoveUpvote(tokenCID, props.address);
        loggingUtils.logEvent(
          props.address != null ? props.address : encryptUtils.getWalletUnconnectedUserId(),
          "videos",
          "videos_unlike_item",
          "info",
          "https://the402.xyz",
          {
            video: props.video,
          }
        );
        setIsHeartClicked(false);
        setTotalUpvotes(totalUpvotes - 1);
      }
    }
  }

  async function buyBondingCurveItem() {
    if (window.ethereum == null) {
      window.open("https://metamask.app.link/dapp/" + window.location.host + window.location.pathname + window.location.search);
      return;
    }
    if (props.address == null) {
      onUserClickedConnectWallet(
        "videos_mint_bonding_curve_nft_wallet_unconnected"
      );
      return;
    }
    let ethBalance = await encryptUtils.getEthBalance(props.address);
    if (ethBalance < props.video.mintPrice) {
      alert(
        "You do not have enough funds in your wallet to purchase an edition."
      );
      return;
    }
    props.setTransactionStatus("Pending");
    let didApprove = await encryptUtils.buyBondingCurveItem(
      props.address,
      props.video,
      props.video.protocol
    );
    if (didApprove) {
      loggingUtils.logEvent(
        props.address,
        "videos",
        "videos_mint_bonding_curve_nft",
        "info",
        "https://the402.xyz",
        {
          item: props.video,
        }
      );
    } else {
      props.setTransactionStatus("None");
    }
  }

  async function sellBondingCurveItem() {
    if (window.ethereum == null) {
      window.open("https://metamask.app.link/dapp/" + window.location.host + window.location.pathname + window.location.search);
      return;
    }
    if (props.address == null) {
      onUserClickedConnectWallet(
        "videos_sell_bonding_curve_nft_wallet_unconnected"
      );
      return;
    }
    props.setTransactionStatus("Pending");
    let didApprove = await encryptUtils.sellBondingCurveItem(
      props.address,
      props.video,
      props.video.protocol
    );
    if (didApprove) {
      loggingUtils.logEvent(
        props.address,
        "videos",
        "videos_sell_bonding_curve_nft",
        "info",
        "https://the402.xyz",
        {
          item: props.video,
        }
      );
    } else {
      props.setTransactionStatus("None");
    }
  }

  useEffect(() => {
    if (
      props.video.liquidityPeriodLength != null &&
      props.video.liquidityPeriodStart != null &&
      props.video.liquidityPeriodStart !== "-1" &&
      props.video.liquidityPeriodLength !== "0"
    ) {
      setInterval(() => {
        let end =
          parseInt(props.video.liquidityPeriodLength) +
          parseInt(props.video.liquidityPeriodStart);
        let secondsLeft = end - Date.now() / 1000;
        if (secondsLeft < 0) {
          setIsFinished(true);
        }
      }, 1000);
    }
  }, []);

  return (
    <div
        className="border-2 border-gray-200 rounded-t-none cursor-pointer dark:border-zinc-800 w-full sm:w-96 mx-auto mb-8 dark:bg-custom-gray bg-gray-100 rounded-none sm:rounded-xl">
      <div className="h-96">
        {props.video.protocol !== "the402" && props.video.mediaType === 0 ? (
          <img className="object-cover bg-black h-96 w-full sm:h-96 sm:w-96 rounded-none sm:rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)]" src={props.video.imagePinata} onClick={handleClickVideo} />
        ) : (
          <img className="object-cover bg-black h-96 w-full sm:h-96 sm:w-96 rounded-none sm:rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.4)]" src={props.video.imagePinata} onClick={handleClickVideo} />
        )}
        <div className="relative bg-black bg-opacity-5 bottom-96 py-2 z-0">
          <div className="flex mr-8 justify-between relative text-white font-medium left-4 z-10">
            {props.video.creatorName}
            {
              props.address != null &&
              props.video.creatorAddress.toLowerCase() in props.subscriberStatuses &&
              props.address.toLowerCase() in props.subscriberStatuses[props.video.creatorAddress.toLowerCase()]
                ?
              <div>
                Subscribed
              </div>
                :
              <div className="cursor-pointer" onClick={(e) => {
                e.stopPropagation();
                props.selectItemForSubscribe(props.video)
              }}>
                Subscribe
              </div>
            }
          </div>
          <div className="relative text-xl text-white font-bold left-4 z-10">
            {props.video.name}
          </div>
        </div>
      </div>
      <div className="flex flex-col cursor-pointer" onClick={handleClickVideo}>
        <div className="p-4 flex bg-gray-100 dark:bg-custom-gray">
          <div className="w-9/12 h-10 overflow-hidden text-ellipsis text-sm font-medium text-black dark:text-white">
            {props.video.description}
          </div>
          <div className="flex inline-flex w-14 ml-1">
            {isHeartClicked ? (
              <IoMdHeart
                onClick={async (e) => {
                  e.stopPropagation();
                  await onClickHeart();
                }}
                color="red"
                className="text-gray-500 dark:text-gray-400 text-xl cursor-pointer"
              />
            ) : (
              <IoMdHeartEmpty
                onClick={async (e) => {
                  e.stopPropagation();
                  await onClickHeart();
                }}
                className="text-gray-500 dark:text-gray-400 text-xl cursor-pointer"
              />
            )}
            <div className="ml-2 text-sm font-medium text-black dark:text-white">
              {totalUpvotes}
            </div>
          </div>
          {isCopied ? (
            <IoIosCheckmarkCircle className="text-green-500 text-lg" />
          ) : (
            <IoArrowRedoOutline
              className="text-gray-500 dark:text-gray-400 text-xl cursor-pointer"
              onClick={onClickShareLink}
              onMouseEnter={() => setCopyMessage("Share")}
              onMouseLeave={() => setCopyMessage("")}
            />
          )}
          <div className="videosRowItemCopyMessage">{copyMessage}</div>
        </div>
        {props.video.protocol !== "the402" && !isFinished ? (
          <div className="h-32 bg-gray-100 dark:bg-custom-gray dark:border-t-1 rounded-b-xl dark:border-zinc-800 border-t-2 flex flex-col justify-center">
            <div className="flex justify-around">
              <div className="cursor-pointer">
                <div className="flex flex-col">
                  <div
                    onClick={async (e) => {
                      e.stopPropagation();
                      await buyBondingCurveItem();
                    }}
                    className={
                      !props.video.isNonLiquid
                        ?
                      "hover:-translate-y-0 hover:scale-105 duration-500 hover:bg-zinc-800 dark:hover:bg-zinc-300 ml-2 mx-auto bg-custom-black dark:bg-gray-200 h-12 w-44 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer"
                        :
                      "hover:bg-zinc-800 dark:hover:bg-zinc-300 ml-2 mx-auto bg-custom-black dark:bg-gray-200 h-12 sm:w-52 w-60 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer"
                    }
                  >
                    Buy
                  </div>
                  <div className="flex flex-col items-center justify-center">
                    <div className="text-md dark:text-white font-bold">
                      {(props.video.baseBuyPrice / ethToWeiConversion).toFixed(3) + " ETH"}
                    </div>
                    <div className="text-sm dark:text-gray-500">
                      {props.video.currentBuyFeePerThousand/10 + "% creator fee"}
                    </div>
                    <div className="flex text-sm text-gray-500">
                      {(props.video.mintPrice / ethToWeiConversion).toFixed(3) + " ETH"}
                    </div>
                  </div>
                </div>
              </div>
              {
                !props.video.isNonLiquid
                  ?
                <div className="cursor-pointer">
                  <div className="flex flex-col">
                    <div
                      className="hover:-translate-y-0 hover:scale-105 duration-500 hover:bg-gray-300 dark:hover:bg-zinc-700 mr-2 mx-auto bg-gray-200 dark:bg-zinc-800 h-12 w-44 font-semibold justify-center items-center rounded-lg flex font-medium text-zinc-800 dark:text-gray-300 cursor-pointer"
                      onClick={async (e) => {
                        e.stopPropagation();
                        await sellBondingCurveItem();
                      }}
                    >
                      Sell
                    </div>
                    <div className="flex flex-col items-center justify-center">
                      <div className="text-md dark:text-white font-bold">
                        {(props.video.baseSellPrice / ethToWeiConversion).toFixed(3) + " ETH"}
                      </div>
                      <div className="text-sm dark:text-gray-500">
                        {props.video.currentSellFeePerThousand/10 + "% creator fee"}
                      </div>
                      <div className="flex text-sm text-gray-500">
                        {(props.video.sellPrice / ethToWeiConversion).toFixed(3) + " ETH"}
                      </div>
                    </div>
                  </div>
                </div>
                  :
                null
              }
            </div>
          </div>
        ) : (
          <div className="h-28 bg-gray-100 dark:bg-custom-gray dark:border-t-1 dark:border-zinc-800 border-t-2 flex flex-col justify-center">
            <div className="flex justify-around">
              <div
                onClick={handleClickVideo}
              >
                <div className="hover:-translate-y-0 hover:scale-105 duration-500 ml-2 mx-auto bg-custom-black dark:bg-gray-200 h-12 w-52 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer">
                  View
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default VideosRowItem;
